import React from "react";
export default function SVGTake() {
  return (
    <svg height="512" viewBox="0 0 512 512" width="512">
      <g fill="#000000">
        <path
          fill="#000000"
          d="m497.72 277.05c-18.431-18.436-47.984-19.15-67.285-1.623l-65.068 59.093c-7.488-17.316-24.732-29.466-44.765-29.466h-81.917c-19.765-20.101-46.762-31.5-75.12-31.5-21.655 0-42.511 6.655-59.965 18.749-6.341-15.851-21.845-27.082-39.933-27.082h-63.667v221.227h63.667c19.554 0 36.09-13.125 41.29-31.024l68.137 23.029h187.313l136.677-131.812c9.497-9.159 14.794-21.468 14.915-34.662.119-13.193-4.951-25.598-14.279-34.929zm-421.053 166.398c0 7.168-5.832 13-13 13h-33.667v-161.227h33.667c7.168 0 13 5.832 13 13zm399.591-118.401-127.961 123.406h-170.271l-71.36-24.118v-94.802c14.348-16.51 35.058-25.977 56.898-25.977 21.977 0 42.814 9.578 57.172 26.279l4.489 5.221h95.376c10.339 0 18.75 8.411 18.75 18.75s-8.411 18.75-18.75 18.75h-85.583v30h85.583c18.663 0 34.902-10.547 43.092-25.989l86.91-78.93c7.431-6.748 18.807-6.471 25.899.625 3.591 3.592 5.543 8.367 5.496 13.445-.045 5.076-2.084 9.815-5.74 13.34z"
        />
        <path
          fill="#000000"
          d="m411.72 25.552h-219.896v219.896h219.896zm-126.843 30h33.79v35.555h-33.79zm96.843 159.896h-159.896v-159.896h33.053v65.555h93.79v-65.555h33.053z"
        />
      </g>
    </svg>
  );
}
